export default "__VITE_ASSET__B7XO7MRi__"